import { useBackend } from "../../services";
import { useEffect, useState } from "react";
import { StatusCodesHelper } from "../../models/StatusCodesHelper";
import { toast } from "react-toastify";
import { DataStorage } from "../../models/DataStorage";

export const useGetSleeveGrades = <T>(
  setLoading: (loading: boolean) => void,
  dependencies: T[] = []
) => {
  const { get } = useBackend();
  const storage = DataStorage.sleeveGradeStorage;
  const [sleeveGrades, setSleeveGrades] = useState(storage.getData(false, ""));
  useEffect(() => {
    if (sleeveGrades && sleeveGrades.length > 0) return;
    setLoading(true);
    get("sleeveGrades").then(({ body, status }) => {
      if (StatusCodesHelper.isSuccessful(status)) {
        setSleeveGrades(body);
        storage.setData(body, false, "");
      } else if (!StatusCodesHelper.isSessionExpired(status)) {
        toast.error(body.message);
      }
      setLoading(false);
    });
  }, dependencies);
  return sleeveGrades;
};
